const MAP = {
  BOZZA: ["Bozza", "bg-slate-100 text-slate-700 border-slate-200", "bg-slate-400"],
  INVIATA: ["Inviata a SdI", "bg-sky-50 text-sky-700 border-sky-200", "bg-sky-500"],
  CONSEGNATA: ["Consegnata", "bg-emerald-50 text-emerald-700 border-emerald-200", "bg-emerald-500"],
  MANCATA_CONSEGNA: ["Mancata consegna", "bg-amber-50 text-amber-700 border-amber-200", "bg-amber-500"],
  SCARTATA: ["Scartata", "bg-rose-50 text-rose-700 border-rose-200", "bg-rose-500"],
  RICEVUTA: ["Ricevuta", "bg-indigo-50 text-indigo-700 border-indigo-200", "bg-indigo-500"],
};

export const StatusBadge = ({ status }) => {
  const [label, cls, dot] = MAP[status] || [status, "bg-slate-100 text-slate-700 border-slate-200", "bg-slate-400"];
  return (
    <span data-testid={`sdi-status-${String(status).toLowerCase()}`} className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold ${cls}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${dot}`} />
      {label}
    </span>
  );
};

export const PayBadge = ({ inv }) => {
  if (inv.tipo === "TD04") return <span className="text-xs text-slate-400">—</span>;
  const overdue = !inv.pagata && inv.scadenza && inv.scadenza < new Date().toISOString().slice(0, 10);
  const cls = inv.pagata ? "text-emerald-700 bg-emerald-50" : overdue ? "text-rose-700 bg-rose-50" : "text-amber-700 bg-amber-50";
  return <span className={`rounded px-2 py-0.5 text-xs font-medium ${cls}`}>{inv.pagata ? "Pagata" : overdue ? "Scaduta" : "Da pagare"}</span>;
};
